import React from "react";
import { Container } from "react-bootstrap";
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";
import "../components/css/App.css";
import { Toaster, ToastBar } from "react-hot-toast";


export default function Base({ children }) {
  return (
    <div className="page-wrapper bg">
      <NavigationBar />

      <div className="page-content">

        <br />
        <Container className="content-container" style={{ margin: "auto", width: "90%" }} fluid>
          {children}
        </Container>
        <br />
      </div>

      <Footer />
      <Toaster
        toastOptions={{
          duration: 4000,
          position: "bottom-right",
        }}
      />

    </div>
  );
}
